"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.motorAndDriveResults = exports.fanResults = void 0;
exports.fanResults = "fptfanresults";
exports.motorAndDriveResults = "fptmotoranddriveresults";
//# sourceMappingURL=result-group-names.js.map